import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import userPic from '@/assets/components/profile/user--sm.png';
import { ProgressBar } from '@/components/ProgressBar';
import { PlayerLevel, User } from '@/types/models';

import styles from '../../Profile.module.scss';

type MainProps = {
  user: User;
  nextLevel: PlayerLevel;
  xpBar: number;
  className?: string;
};

export const ProfileMain = observer<MainProps>(
  ({ user, nextLevel, xpBar, className }) => (
    <div className={clsx(styles['profile__main'], className)}>
      <div className={clsx(styles['profile__ava'], 'in-col-center')}>
        <img src={userPic} alt="" />
      </div>
      <div className={styles['profile__name']}>{user.name}</div>
      {user.level && (
        <ProgressBar
          width={xpBar}
          leftProgress={`Lv. ${user.level}`}
          rightProgress={`Lv. ${nextLevel.level}`}
        />
      )}
    </div>
  ),
);
